import { __assign } from "tslib";
import { Dialog, styled } from '@mui/material';
// const variantMixIn = ({ theme, variant }: any) => ({
//   ...(variant === 'basic' && {
//     minWidth: `480px`,
//     maxWidth: `600px`,
//     boxShadow: `0 3px 6px 0 rgba(0, 0, 0, 0.24)`,
//     borderRadius: `2px`,
//     boxSizing: `border-box`,
//     // [theme.breakpoints.down('md')]: {
//     //   minWidth: 0,
//     //   maxWidth: `none`,
//     //   width: `100%`,
//     //   margin: 20,
//     // },
//     '.MuiDialogTitle-root': {
//       padding: 24,
//       [theme.breakpoints.down('md')]: {
//         padding: 20,
//       },
//     },
//     '.MuiDialogContent-root': {
//       paddingTop: 8,
//       paddingBottom: 8,
//       paddingLeft: 24,
//       paddingRight: 24,
//       [theme.breakpoints.down('md')]: {
//         paddingLeft: 20,
//         paddingRight: 20,
//       },
//     },
//     '.MuiDialogActions-root': {
//       padding: 24,
//       button: {
//         '+ button': {
//           marginLeft: 6,
//         },
//       },
//       [theme.breakpoints.down('md')]: {
//         padding: 20,
//       },
//     },
//   }),
//   ...(variant === 'alert' && {
//     minWidth: `340px`,
//     maxWidth: `480px`,
//     // width: `${width}px`,    padding: 24,
//     boxShadow: `0 3px 6px 0 rgba(0, 0, 0, 0.24)`,
//     borderRadius: `2px`,
//     padding: 24,
//     boxSizing: `border-box`,
//     // [theme.breakpoints.down('md')]: {
//     //   minWidth: 0,
//     //   maxWidth: `none`,
//     //   padding: 20,
//     //   width: `100%`,
//     //   margin: 20,
//     // },
//     '.MuiDialogTitle-root': {},
//     '.MuiDialogContent-root': {
//       paddingTop: 0,
//       paddingBottom: 8,
//       paddingLeft: 0,
//       paddingRight: 0,
//     },
//     '.MuiDialogActions-root': {
//       padding: 0,
//       paddingTop: 24,
//       button: {
//         '+ button': {
//           marginLeft: `4px`,
//         },
//       },
//       [theme.breakpoints.down('md')]: {
//         paddingTop: 20,
//       },
//     },
//   }),
//   ...(variant === 'option' && {
//     minWidth: `660px`,
//     maxWidth: `1280px`,
//     border: `1px solid ${theme.palette.greySecondary[600]}`,
//     '.MuiDialogContent-root': {
//       padding: 24,
//       [theme.breakpoints.down('md')]: {
//         paddingTop: 12,
//         paddingLeft: 20,
//         paddingRight: 20,
//         paddingBottom: 20,
//       },
//     },
//     // [theme.breakpoints.down('md')]: {
//     //   minWidth: 0,
//     //   maxWidth: `none`,
//     //   width: `100%`,
//     //   margin: 20,
//     // },
//   }),
//   ...(variant === 'expandable' && {
//     boxShadow: `0 2px 4px 0 rgba(0, 0, 0, 0.24)`,
//     borderRadius: `2px`,
//     margin: 60,
//     maxHeight: `calc(100% - 120px)`,
//     maxWidth: `100%`,
//     minWidth: `768px`,
//     // width: `${width}px`,
//     boxSizing: `border-box`,
//     // [theme.breakpoints.down('md')]: {
//     //   minWidth: 0,
//     //   maxWidth: `none`,
//     //   width: `100%`,
//     //   maxHeight: `calc(100% - 40px)`,
//     //   margin: 20,
//     // },
//     '.MuiDialogTitle-root': {
//       paddingTop: 20,
//       paddingBottom: 20,
//       paddingLeft: 24,
//       paddingRight: 24,
//       boxSizing: `border-box`,
//       [theme.breakpoints.down('md')]: {
//         paddingRight: 20,
//         paddingLeft: 20,
//       },
//     },
//     '.MuiDialogContent-root': {
//       padding: `0 24px`,
//       [theme.breakpoints.down('md')]: {
//         padding: `0 20px`,
//       },
//     },
//     '.MuiDialogActions-root': {
//       padding: 24,
//       borderTop: `1px solid ${theme.palette.greySecondary[100]}`,
//       [theme.breakpoints.down('md')]: {
//         padding: 20,
//       },
//     },
//   }),
// });
export var StyledDialog = styled(Dialog, {
    shouldForwardProp: function (prop) {
        return !['variant', 'informationOpen'].includes(String(prop));
    },
})(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var theme = _a.theme, variant = _a.variant, informationOpen = _a.informationOpen;
    return ({
        '.MuiDialogTitle-root': __assign(__assign(__assign(__assign(__assign({}, (variant === 'basic' && {
            padding: theme.spacing(3),
        })), (variant === 'alert' && {})), (variant === 'simple' && {
            padding: theme.spacing(2.5),
            paddingBottom: theme.spacing(1.5),
        })), (variant === 'option' && {})), (variant === 'expandable' && {
            padding: theme.spacing(3),
            paddingTop: theme.spacing(2.5),
            paddingBottom: theme.spacing(2.5),
        })),
        '.MuiDialogContent-root': __assign(__assign(__assign(__assign(__assign({ scrollbarGutter: "stable " }, (variant === 'basic' && {
            padding: theme.spacing(0, 3),
        })), (variant === 'alert' && {
            paddingBottom: 0,
        })), (variant === 'simple' && {
            padding: theme.spacing(2.5),
            paddingTop: 0,
        })), (variant === 'option' && {
            padding: theme.spacing(3),
            //scrollbar width 6 만큼 빼서 적용
            paddingRight: theme.spacing(1.75),
        })), (variant === 'expandable' && {
            paddingRight: theme.spacing(2.25),
        })),
        '.MuiDialogActions-root': __assign(__assign(__assign(__assign(__assign({}, (variant === 'basic' && {
            padding: theme.spacing(3),
        })), (variant === 'alert' && {
            padding: theme.spacing(3),
        })), (variant === 'simple' && {})), (variant === 'option' && {
            padding: theme.spacing(3),
        })), (variant === 'expandable' && {
            padding: theme.spacing(3),
        })),
        '.MuiDialog-paper': __assign(__assign(__assign(__assign(__assign({}, (variant === 'basic' && (_b = {
                gap: 8,
                minWidth: 480
            },
            _b[theme.breakpoints.down('md')] = {
                minWidth: 328,
            },
            _b['&:not(:has(.MuiDialogTitle-root))'] = {
                '.MuiDialogContent-root': {
                    paddingTop: theme.spacing(3),
                },
            },
            _b['&:not(&.MuiDialog-paperFullScreen)'] = {
                maxWidth: 600,
            },
            _b))), (variant === 'alert' && (_c = {
                minWidth: 360
            },
            _c[theme.breakpoints.down('md')] = {
                minWidth: 328,
            },
            _c['&:not(&.MuiDialog-paperFullScreen)'] = {
                maxWidth: 480,
            },
            _c))), (variant === 'simple' && (_d = {
                minWidth: 240
            },
            _d[theme.breakpoints.down('md')] = {
                minWidth: 200,
            },
            _d.border = "1px solid ".concat(theme.palette.greySecondary[600]),
            _d['&:not(:has(.MuiDialogTitle-root))'] = {
                '.MuiDialogContent-root': {
                    paddingTop: theme.spacing(2.5),
                },
            },
            _d['&:not(&.MuiDialog-paperFullScreen)'] = (_e = {
                    maxWidth: 400
                },
                _e[theme.breakpoints.down('md')] = {
                    maxWidth: 360,
                },
                _e),
            _d))), (variant === 'option' && (_f = {
                minWidth: 660
            },
            _f[theme.breakpoints.down('md')] = {
                minWidth: 328,
            },
            _f['&:not(&.MuiDialog-paperFullScreen)'] = (_g = {
                    maxWidth: 1280
                },
                _g[theme.breakpoints.down('md')] = {
                    maxWidth: 840,
                },
                _g),
            _f))), (variant === 'expandable' && (_h = {
                minWidth: 768
            },
            _h[theme.breakpoints.down('md')] = {
                minWidth: 360,
            },
            //info panel
            _h['&:has(.MuiDrawer-root)'] = __assign(__assign({ paddingRight: theme.spacing(6), transition: "padding 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms" }, (informationOpen && {
                paddingRight: "336px",
            })), (_j = {}, _j[theme.breakpoints.down('md')] = __assign({ transition: "none" }, (informationOpen && {
                paddingRight: 0,
            })), _j['& .MuiPaper-root'] = (_k = {
                    minWidth: theme.spacing(6)
                },
                _k[theme.breakpoints.down('md')] = __assign({}, (informationOpen && {
                    minWidth: "0",
                    width: "100%",
                })),
                _k), _j)),
            _h))),
        // '.MuiDialog-container': {
        //   '> form > .MuiPaper-root, > .MuiPaper-root': {
        //     // '&:not(&.MuiDialog-paperFullScreen)': {
        //     //   backgroundColor: `red`,
        //     //   [theme.breakpoints.down('md')]: {
        //     //     minWidth: 0,
        //     //     maxWidth: `none`,
        //     //     width: `100%`,
        //     //     backgroundColor: `blue`,
        //     //     '&:not(&.MuiDialog-paperFullScreen)': {
        //     //       margin: 20,
        //     //       backgroundColor: `blue`,
        //     //     },
        //     //   },
        //     // },
        //     // [theme.breakpoints.down('md')]: {
        //     //   minWidth: 0,
        //     //   maxWidth: `none`,
        //     //   width: `100%`,
        //     //   '&:not(&.MuiDialog-paperFullScreen)': {
        //     //     margin: 20,
        //     //     backgroundColor: `blue`,
        //     //   },
        //     // },
        //     '.MuiPaper-root': {
        //       backgroundColor: `red`,
        //     },
        //     '.MuiDialogTitle-root': {
        //       padding: 24,
        //       [theme.breakpoints.down('md')]: {
        //         padding: 20,
        //       },
        //       ' + .MuiDialogContent-root': {
        //         paddingTop: 8,
        //         paddingBottom: 8,
        //       },
        //     },
        //     '.MuiDialogContent-root': {
        //       paddingTop: 8,
        //       paddingBottom: 8,
        //       paddingLeft: 24,
        //       paddingRight: 24,
        //       [theme.breakpoints.down('md')]: {
        //         paddingLeft: 20,
        //         paddingRight: 20,
        //       },
        //     },
        //     '.MuiDialogActions-root': {
        //       padding: 24,
        //       [theme.breakpoints.down('md')]: {
        //         padding: 20,
        //       },
        //     },
        //     // ...(variant !== undefined && variantMixIn({ theme, variant })),
        //     '&:has(.MuiDrawer-root)': {
        //       paddingRight: 48,
        //       transition: `padding 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms`,
        //       // 모바일 버전 확정 전까지 제외
        //       // [theme.breakpoints.down('md')]: {
        //       //   paddingRight: 0,
        //       //   ...(informationOpen && {
        //       //     paddingRight: `0`,
        //       //   })
        //       // },
        //       // ...(informationOpen && {
        //       //   paddingRight: `336px`,
        //       // })
        //     },
        //   },
        // },
    });
});
//# sourceMappingURL=styled.js.map